<template>
  <div class="pagination">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="5"
      :page-sizes="pageSizes" :layout="layout" :current-page.sync="base_currentPage"
      :page-size="limit" :total="total" :small="small"></el-pagination>
  </div>
</template>
<script>
export default {
  name: "pagination",
  data() {
    return {
      base_currentPage: this.currentPage,
      layout:"total, sizes, prev, pager, next, jumper",
      // layout:"prev, pager, next",
    };
  },
  props: {
    currentPage: {
      required: false,
      default: 1,
    },
    pageSizes: {
      required: false,
      default: function () {
        return [5, 10, 12, 20, 30, 40, 50, 60, 80, 100];
      },
    },
    total: {
      required: false,
      default: 0,
    },
    limit: {
      required: false,
      default: 10,
    },
    small: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  watch: {
    //监听aboutdata数据变化
    total(newdata, olddata) {
      this.total = newdata;
    },
    currentPage: function (newList) {
      this.base_currentPage = newList;
    }
  },
  created(){
    if(window.innerWidth <= 650){
      this.layout = "prev, pager, next";
    }else{
      this.layout = "total, sizes, prev, pager, next, jumper";
    }
  },
  methods: {
    // 当前页变化
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    // size变化
    handleSizeChange(val) {
      this.base_currentPage = 1;
      this.$emit("handleSizeChange", val);
    },
  },

};
</script>
<style scoped>
.pagination {
  margin: 20px 0;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Page.vue